define('services/routing/emailDomainService',[
    'lib/lodash4',
    'services/apiCore'
], function (
    _,
    apiCore
) {
    'use strict';
    return {
        get: {
            page: function (data) {
                var endpoint = "/routing/email/domains";
                data = data || {};
                data = _.assign({
                    excludeStatus: true,
                    pageSize: 25,
                    pageNumber: 1,
                    filter: ""
                }, data);

                return apiCore.v2.get(endpoint, data);
            }
        }
    };
});

